export default __webpack_public_path__ + "static/media/immaginelore4.bd353efb.png";